$(document).ready(function(e){
    SLIDE.setSlide();
});

var SLIDE = Object();

SLIDE.setSlide = function(){
    $('.home-slide .wrap .slide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        prevArrow: '<div class="prev"></div>',
        nextArrow: '<div class="next"></div>',
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
    $('.slide-videos .wrap .slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        prevArrow: '<div class="prev"></div>',
        nextArrow: '<div class="next"></div>',
        asNavFor: '.slide-videos .wrap .slider-thumbs',
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
    $('.slide-videos .wrap .slider-thumbs').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: '0px',
        prevArrow: '<div class="prev"></div>',
        nextArrow: '<div class="next"></div>',
        asNavFor: '.slide-videos .wrap .slider',
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                }
            },
        ]
    });

    $('.testimonios .slide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        prevArrow: '<div class="prev"></div>',
        nextArrow: '<div class="next"></div>',
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
}

$(document).on('click','.home-slide .wrap .slide .textos .slide-nav .ll',function(){
    $('.home-slide .wrap .slide').slick('slickPrev');
});
$(document).on('click','.home-slide .wrap .slide .textos .slide-nav .rr',function(){
    $('.home-slide .wrap .slide').slick('slickNext');
});

$(document).on('click','.testimonios .wrap .slide .imagen .l',function(){
    $('.testimonios .slide').slick('slickPrev');
});
$(document).on('click','.testimonios .wrap .slide .imagen .r',function(){
    $('.testimonios .slide').slick('slickNext');
});
